import { render, staticRenderFns } from "./ProductPriceImportExportModal.vue?vue&type=template&id=a3af7df6&scoped=true"
import script from "./ProductPriceImportExportModal.vue?vue&type=script&lang=js"
export * from "./ProductPriceImportExportModal.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceImportExportModal.vue?vue&type=style&index=0&id=a3af7df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3af7df6",
  null
  
)

export default component.exports